<script>

export default {
  props: ['item', 'isnew'],
  data() {
    return {
      loading: true,
      filters: {
        paginate: 1000,
        page: 1,
        total: 0,
        wheres: {
          website_id: '',
        },
      },
      website: {},
    }
  },
  watch: {
    'item.website': { handler: function(n, o) {
      this.filters.wheres.website_id = n;
      this.fetchData();
    }, immediate: true },
  },
  created() {

  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/websites/fetch', {params: this.filters}).then(res => {
        if(res.data.data.length == 1) {
          this.website = res.data.data[0];
        } else {
          this.$noty.warning("FAQ categories could not be found.");
        }
        this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    changeEditor(type) {
      var n = this.$noty.error('<div class="p-3"><h3 class="text-white">Are you sure you would like to change editors?</h3><div>Changing the content type can cause data to be lost, specifically when changing to the Document editor as all data will be parsed.</div></div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light', res => {
            this.item.content_type = type;
            this.$forceUpdate();
            n.close();
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { });
    },

  }
}
</script>

<template>
  <div>
    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> FAQ details :</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Title :" v-model="item.title" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String List, Multi" Title="Categories :" v-model="item.categories" :Options="website.blog_categories"></w-field>
      </div>
      <div class="col-sm-12">
        <label for="col-bd">Content :</label>
        <div class="row m-0 mb-3">
          <div class="col-12 col-sm-6 p-0">
            <button type="button" class="btn btn-block" :class="item.content_type == 'doc' ? 'btn-primary' : 'btn-white'" @click="changeEditor('doc')">Document editor</button>
          </div>
          <div class="col-12 col-sm-6 p-0">
            <button type="button" class="btn btn-block" :class="item.content_type == 'html' ? 'btn-primary' : 'btn-white'" @click="changeEditor('html')">HTML Editor</button>
          </div>
        </div>
        <component v-if="item.content_type == 'html'" is="PrismEditorMain" v-model="item.content"></component>
        <component v-else is="CkRichEditor" v-model="item.content"></component>
      </div>
    </div>

    <div class="clearfix mt-3"></div>

  </div>
</template>
